export default __webpack_public_path__ + "static/media/img-survey.06f5a14e.svg";